import { FAQ_ITEMS } from '../faq-items'

export const useFilterFaqItems = (searchValue: string) => {
  return FAQ_ITEMS.filter(
    x =>
      x.title.toLowerCase().includes(searchValue.toLowerCase()) ||
      x.content.toLowerCase().includes(searchValue.toLowerCase())
  )
}
